var path = 'jangl/extra-fields/template.html';
var html = "<h2>Extra data</h2> <hr/> <div ng-repeat=\"fields in $ctrl.fields\" ng-if=\"$index % 2 == 0\" class=row> <div class=col-md-6 ng-repeat=\"field in $ctrl.fields.slice($index, ($index+2 > $ctrl.fields.length ? $ctrl.fields.length : $index+2))\"> <jangl-input form=$ctrl.form label={{field.label}} name=extra.{{field.name}} model=$ctrl.passthrough[field.name] required=true></jangl-input> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/jangl/extra-fields/template.html
// module id = 360
// module chunks = 0